import { render } from "./IndustrialClientsView.vue?vue&type=template&id=c1353f92"
import script from "./IndustrialClientsView.vue?vue&type=script&lang=js"
export * from "./IndustrialClientsView.vue?vue&type=script&lang=js"

import "./IndustrialClientsView.vue?vue&type=style&index=0&id=c1353f92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__